<script>
  import { cn } from '@lib/utils'

  let { title, label, class: className, children } = $props()

</script>

<div class={cn('border border-primary-300 rounded-md relative', className)}>
  
  {#if title || label}
    <div class="bg-primary-50/50 px-6 py-3 border-4 border-white border-b border-b-primary-100/80 rounded-md">
      {#if label}
        <div class="min-h-8">
          <h6 class="font-medium bg-white text-gray-500 text-xs inline-block">{label}</h6>
        </div>
      {/if}
      {#if title}
        <h5 class="font-serif text-gray-700 text-xl">{title}</h5>
      {/if}
    </div>
  {/if}

  <div class="p-6 text-sm text-gray-500">
    {@render children?.()}
  </div>
</div>